export function LoadingState({ label = 'Loading' }) {
  return (
    <div className="state-block">
      <div className="spinner" />
      <div className="muted" style={{ fontWeight: 800, fontSize: 13 }}>{label}</div>
    </div>
  );
}

export function ErrorState({ message, onRetry }) {
  return (
    <div className="state-block state-error">
      <div className="state-icon state-icon-danger" aria-hidden="true">!</div>
      <div className="state-title">Something went wrong</div>
      <div className="muted state-message">{message || 'Try again in a moment.'}</div>
      {onRetry ? <button className="btn btn-ghost btn-sm" onClick={onRetry}>Retry</button> : null}
      <style>{stateStyles}</style>
    </div>
  );
}

export function EmptyState({ title, message, icon }) {
  return (
    <div className="state-block">
      <div className="state-icon state-icon-glow" aria-hidden="true">{icon || '✨'}</div>
      <div className="state-title">{title}</div>
      {message ? <div className="muted state-message">{message}</div> : null}
      <style>{stateStyles}</style>
    </div>
  );
}

const stateStyles = `
.state-icon {
  width: 56px; height: 56px;
  display: inline-flex; align-items: center; justify-content: center;
  border-radius: 50%;
  font-size: 24px;
  border: 1px solid var(--line-soft);
}
.state-icon-danger {
  color: var(--danger);
  background: rgba(255, 85, 119, 0.12);
  border-color: rgba(255, 85, 119, 0.32);
  font-weight: 900;
  font-size: 28px;
}
.state-icon-glow {
  color: var(--primary);
  background: rgba(255, 62, 127, 0.10);
  border-color: rgba(255, 62, 127, 0.28);
}
.state-title { font-weight: 900; font-size: 16px; }
.state-message { font-size: 13px; max-width: 420px; }
`;
